<template>
    <div>
        <span class="stock-level" :class="stockLevelClass">{{ text }}</span>
    </div>
</template>

<script>
    export default {
        props: ['stock', 'backorder', 'incoming', 'deliverydays'],
        data() {
            return {
                lowLimit: 15
            }
        },
        computed: {
            text() {
                if (this.sufficientStock) {
                    return this.stock + ' items in stock';
                } else if (this.lowStock) {
                    return 'Only ' + this.stock + ' items left in stock';
                } else if (this.hasIncoming) {
                    return (this.stock + this.incoming) + ' available for backorder';
                }
                return this.deliverydays ? 'Available in ' + this.deliverydays : 'Available for backorder';
            },
            sufficientStock() {
                return this.stock > this.lowLimit;
            },
            lowStock() {
                return this.stock > 0 && this.stock <= this.lowLimit;
            },
            hasIncoming() {
                return this.incoming && this.backorder == 'expected';
            },
            alwaysOrder() {
                return this.backorder == 'always';
            },
            stockLevelClass() {
                return {
                    'in-stock' :  this.sufficientStock,
                    'low-stock' : !this.sufficientStock || this.lowStock || this.hasIncoming,
                    'out-of-stock' : !this.sufficientStock && !this.lowStock && !this.hasIncoming && !this.alwaysOrder
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Product/StockLevel.vue